import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useLeaderboard } from '@/common/store/Leaderboard/LoaderboardProvider';
import TimeframeFilter from './TimeframeFilter';
import ViewAsFilter from './ViewAsFilter';
import ActivityTypesFilter from './ActivityTypesFilter';
const FilterModal = (props) => {
    const { state } = useLeaderboard();
    const { handleSubmit, control } = useForm();
    const onSubmitHandler = (values) => {
        if (!values.filterExerciseTypes.length) {
            return;
        }
        props.onSubmit(values);
    };
    if (!state) {
        return null;
    }
    const getInitialExerciseTypes = () => {
        if (state.filter.filterExerciseTypes.length === 0) {
            return state.availableActivities.map((activity) => activity.alias);
        }
        return state.filter.filterExerciseTypes;
    };
    return (React.createElement("div", { className: 'modal fade leaderboard-filter', id: 'modal-leaderboard-filter', tabIndex: -1, role: 'dialog', "aria-labelledby": 'modal-leaderboard-filter', "aria-hidden": 'true' },
        React.createElement("div", { className: 'modal-dialog modal-dialog-centered modal-dialog-scrollable' },
            React.createElement("div", { className: 'modal-content' },
                React.createElement("div", { className: 'modal-header' },
                    React.createElement("h3", { className: 'modal-title primary-color' }, "LEADERBOARD SETTINGS AND FILTERS"),
                    React.createElement("button", { type: 'button', className: 'btn-close', "data-bs-dismiss": 'modal', "aria-label": 'Close' })),
                React.createElement("div", { className: 'modal-body' },
                    React.createElement("div", null,
                        React.createElement("p", { className: 'mb-0 weight-600' }, "TIMEFRAME"),
                        React.createElement(Controller, { name: 'filterPeriod', control: control, defaultValue: state.filter.filterPeriod, render: ({ field: { name, value, onChange } }) => (React.createElement(TimeframeFilter, { name: name, value: value, onChange: onChange })) })),
                    React.createElement("div", { className: 'mt-3' },
                        React.createElement("p", { className: 'mb-0 weight-600' }, "VIEW AS"),
                        React.createElement(Controller, { name: 'leaderboardType', control: control, defaultValue: state.filter.leaderboardType, render: ({ field: { name, value, onChange } }) => (React.createElement(ViewAsFilter, { name: name, value: value, onChange: onChange })) })),
                    React.createElement("div", { className: 'mt-3' },
                        React.createElement("p", { className: 'mb-0 weight-600' }, "ACTIVITY TYPES"),
                        React.createElement(Controller, { name: 'filterExerciseTypes', control: control, defaultValue: getInitialExerciseTypes(), render: ({ field: { name, onChange, value }, }) => (React.createElement(ActivityTypesFilter, { name: name, value: value, onChange: onChange, availableActivities: state.availableActivities })) }))),
                React.createElement("div", { className: 'modal-footer' },
                    React.createElement("button", { className: 'small-btn-primary', onClick: handleSubmit(onSubmitHandler) }, "SAVE & CLOSE"))))));
};
export default FilterModal;
